import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-obra-social-paciente',
  templateUrl: './dlg-obra-social-paciente.component.html',
  styleUrls: ['./dlg-obra-social-paciente.component.css']
})
export class DlgObraSocialPacienteComponent implements OnInit {

  idActual="";
  titulo="";
  noTienePlanes=true;
  idObraSocial="";
  nombreObraSocial="";
  txtObraSocial="";
  idPlanObraSocial="";
  nombrePlanObraSocial="";
  txtPlanObraSocial="";
  txtNumAfiliado="";
  tipoGravado="";
  noGravado=true;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgObraSocialPacienteComponent>,
  ) { }

  ngOnInit(): void {
    if (this.storage.get("idConexion")==null){
      this.router.navigate(['/'])
    }
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena
      ,idObraSocialPaciente:this.idActual
      ,idObraSocial: this.idObraSocial
      ,nombreOS: this.nombreObraSocial
      ,idPlan: this.idPlanObraSocial
      ,nombrePlan: this.nombrePlanObraSocial
      ,numAfiliado: this.txtNumAfiliado
      ,tipoGravado: this.tipoGravado
    });
  }

  buscarObraSocial(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Obra social:";
    dlgBusquedas.componentInstance.codBusqueda="OBRASOCIAL";
    dlgBusquedas.componentInstance.txtBusc=this.txtObraSocial;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idObraSocial!=null){
          this.idObraSocial=data.idObraSocial;
          this.nombreObraSocial=data.nombre;
          this.noTienePlanes=data.tienePlanes=="0";
          this.noGravado=data.gravado=="0";
        }
      }
    );
  }

  eliminarObraSocial(){
    this.idObraSocial="";
    this.nombreObraSocial="";
    this.noTienePlanes=true;
    this.idPlanObraSocial="";
    this.nombrePlanObraSocial="";
  }

  buscarPlanObraSocial(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Plan de obra social:";
    dlgBusquedas.componentInstance.codBusqueda="OBRASOCIALPLAN";
    dlgBusquedas.componentInstance.txtBusc=this.txtPlanObraSocial;
    dlgBusquedas.componentInstance.idGeneral=this.idObraSocial;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idPlan!=null){
          this.idPlanObraSocial=data.idPlan;
          this.nombrePlanObraSocial=data.nombre;
        }
      }
    );
  }

  eliminarPlanObraSocial(){
    this.idPlanObraSocial="";
    this.nombrePlanObraSocial="";
  }

  almacenar(){
    if (this.idObraSocial==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar la obra social";
      dlgError.componentInstance.texto="Le falto indicar la obra social";
      return;
    }
    if (this.noTienePlanes==false
        && this.idPlanObraSocial==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar la obra social";
      dlgError.componentInstance.texto="Le falto indicar el plan de la obra social";
      return;
    }
    if (this.txtNumAfiliado==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar la obra social";
      dlgError.componentInstance.texto="Le falto indicar el Nº de afiliado";
      return;
    }
    if (this.noGravado==false
        && this.tipoGravado==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar la obra social";
      dlgError.componentInstance.texto="La Obra social necesita que se indique si es gravado o no";
      return;
    }
    this.cerrar('almaceno');
  }
}
